import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, FormControl, InputLabel, MenuItem, Select, TextField, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TablePagination, Typography, Radio, RadioGroup, Autocomplete, CircularProgress } from '@mui/material';

import { openSnackbar } from "../store/slices/SnackbarSlice";

import { TablePaginationActions } from '../helpers/TablePaginationActions';

import { usePages } from '../hooks/usePages';

import { TableTheadStyle, TablePaddingStyle } from '../styles/TableStyle';

import { ObtenerEstados } from '../connections/catalogos/EstadoConnection';
import { ObtenerMunicipio } from '../connections/catalogos/MunicipioConnection';
import { ObtenerTipoDomicilio } from '../connections/catalogos/TipoDomicilioConnection';
import { ObtenerAsentamientosMunicipio } from '../connections/catalogos/AsentamientoConnection';
import { AgregarDomicilioPersona, ObtenerDomicilioPersona } from '../connections/comun/PersonaConnection';
import { AgregarDomicilioDependencia, ObtenerDomicilioDependencia } from '../connections/catalogos/DependenciaConnection';

import { EstadoProps } from '../interfaces/catalogos/EstadoInterface';
import { MunicipioProps } from '../interfaces/catalogos/MunicipioInterface';
import { AsentamientoParser, defaultAsentamiento } from '../interfaces/catalogos/AsentamientoInterface';
import { TipoDomicilioProps } from '../interfaces/catalogos/TipoDomicilioInterface';
import { defaultDomicilio, DomicilioProps } from '../interfaces/comun/DomicilioInterface';

interface Props {
    openDialog:             boolean;
    idPersona:              number;
    idDependencia?:         number;
    idDomicilio:            number;
    handleCloseDialog:      () => void;
    SeleccionarDomicilio?:  ( persona: DomicilioProps ) => void;
    edit?:                  boolean;
}

export const DialogAgregarDomicilio = ( { openDialog, handleCloseDialog, idPersona, idDependencia = 0, idDomicilio, SeleccionarDomicilio, edit = true }: Props ) => {

    const dispatch = useDispatch();

    const [rows, setRows] = useState<DomicilioProps[]>( [] );

    const [radioSelected, setRadioSelected] = useState( 0 );
  
    const {page, rowsPerPage, handleChangePage, handleChangeRowsPerPage} = usePages( 5 );
   
    const [estado, setEstado] = useState( 0 );
    const [estadoArray, setEstadoArray] = useState<EstadoProps[]>( [] );
    
    const [municipio, setMunicipio] = useState( 0 );
    const [municipioArray, setMunicipioArray] = useState<MunicipioProps[]>( [] );

    const [asentamiento, setAsentamiento] = useState( 0 );
    const [asentamientoArray, setAsentamientoArray] = useState<AsentamientoParser[]>( [] );
    const [autocompleteValue, setAutocompleteValue] = useState<AsentamientoParser | null>( null );
    
    const [tipoDomicilio, setTipoDomicilio] = useState( 0 );
    const [tipoDomicilioArray, setTipoDomicilioArray] = useState<TipoDomicilioProps[]>( [] );
    
    const [descripcion, setDescripcion] = useState( '' );
    const [numero, setNumero] = useState( '' );
    const [referencia, setReferencia] = useState( '' );    

    const [loading, setLoading] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [validateSelected, setValidateSelected] = useState(false);

    const [domicilioSelected, setDomicilioSelected] = useState<DomicilioProps>( defaultDomicilio );

    const handleChangeRadio = ( value: DomicilioProps ) => {

        setRadioSelected( value.idDomicilio ?? 0 );
        setValidateSelected( true );
        setDomicilioSelected( value );

    }

    const validateFiels = () => {
        
        let valid = true;

        if( estado === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un estado', variant: 'warning' }));     
        }
        else if( municipio === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un municipio', variant: 'warning' }));    
        }  
        else if( asentamiento === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un asentamiento', variant: 'warning' }));    
        }

        if( tipoDomicilio === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un asentamiento', variant: 'warning' }));    
        }

        if( descripcion === '' ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes escribir la descripción', variant: 'warning' }));    
        }  

        return valid;
    }

    const resetForm = () => {
        
        setEstado( 0 );
        setMunicipio( 0 );
        setAsentamiento( 0 );
        setAutocompleteValue( null );
        
        setTipoDomicilio( 0 );
        setDescripcion( '' );
        setNumero( '' );         
        setReferencia( '' );       

        setAsentamientoArray( [] );
        setMunicipioArray( [] );
    }

    const handleGuardarDomicilio = async () =>{

        const valid = validateFiels();

        if( !valid ){

            return false;
        }

        setLoading( true );

        const domicilioParams = { idAsentamiento: asentamiento, descripcion, idTipoDomicilio: tipoDomicilio, numero, referencia, };

        // La dependencia conserva un solo domicilio activo: el nuevo reemplaza al anterior y queda seleccionado
        await ( idDependencia !== 0 ? AgregarDomicilioDependencia({ idDependencia, ...domicilioParams }) : AgregarDomicilioPersona({ idPersona, ...domicilioParams }) ).then( resp => {

            setTimeout(() => {

                const { success, message, domicilio } = resp;

                if( success ){

                    if( idDependencia !== 0 ){

                        setRows([ domicilio ]);
                        handleChangeRadio( domicilio );

                    }
                    else{

                        setRows([
                            ...rows,
                            domicilio,
                        ]);

                    }
                    
                    dispatch( openSnackbar({ message: message, variant: 'success' }));  
                    setLoading( false );

                }
                else{

                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoading( false );
                }
                
            }, 700);

        });

    }

    const handleCloseDialogDomicilio = () => {

        handleCloseDialog();
        
        resetForm();        
        setRadioSelected( 0 );
        setRows( [] );               

    }

    const handleAsignarDomicilio = () => {

        setLoadingGuardar( true );

        setTimeout(() => {            

            SeleccionarDomicilio?.( domicilioSelected );  
            handleCloseDialogDomicilio();
            setLoadingGuardar( false );

        }, 700);

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerEstados().then( resp => { 
                setEstadoArray( resp );  
            });

        }

        Obtener();

    }, [ ]);
    
    useEffect(() => {
        
        async function Obtener(){     

            setMunicipio( 0 );

            if( estado !== 0 ){     

                await ObtenerMunicipio( estado ).then( resp => {                 
                    setMunicipioArray( resp );                          
                });
            }

        }

        Obtener();

    }, [ estado ]);

    useEffect(() => {
        
        async function Obtener(){     

            setAsentamiento( 0 );
            setAsentamientoArray( [] );
            setAutocompleteValue( null );

            if( municipio !== 0 ){   

                await ObtenerAsentamientosMunicipio( municipio ).then( resp => {                   
                    setAsentamientoArray( resp );                        
                });
            }

        }

        Obtener();

    }, [ municipio ]);

    useEffect(() => {
        
        async function Obtener(){           

            await ObtenerTipoDomicilio().then( resp => {              
                setTipoDomicilioArray( resp );                   
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){     

            setLoadingSearch( true );            
            setRows( [] );

            if( idPersona !== 0 || idDependencia !== 0 ){

                await ( idDependencia !== 0 ? ObtenerDomicilioDependencia( idDependencia ) : ObtenerDomicilioPersona( idPersona ) ).then( resp => {

                    setTimeout(() => {
                        
                        setRows( resp );
                        setLoadingSearch( false );

                    }, 700);    

                });      

            }
            else{
                setTimeout(() => {
                    
                    setLoadingSearch( false );
                    
                }, 700);                
            }

        }

        if( openDialog ){            
            Obtener();        
        }               

    }, [ idPersona, idDependencia, openDialog ]);

    useEffect(() => {
      
        if( rows.length !== 0 ){

            setRadioSelected( idDomicilio );

            if( idDomicilio !== 0){
                setValidateSelected( true );

                const domicilioActual = rows.find( ( row ) => row.idDomicilio === idDomicilio );

                if( domicilioActual ){
                    setDomicilioSelected( domicilioActual );
                }
            }

        }

    }, [ rows, idDomicilio ]) 

    return (
        <>
            <Dialog 
                fullWidth
                maxWidth='lg' 
                open={ openDialog } 
            >

               <DialogTitle>Domicilio(s) registrado(s)</DialogTitle>

                <DialogContent>
                    
                    <Grid container spacing={3} sx={{ mt: 1 }} >

                        {
                            edit 
                            && 
                                <Grid size={{ md: 12, xs: 12 }}>

                                    <Grid container spacing={3}>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <FormControl fullWidth>

                                                <InputLabel>Estado</InputLabel>
                                                <Select
                                                    label="Estado"
                                                    value={ estado }
                                                    onChange={ e => setEstado( e.target.value ) }
                                                >
                                                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                                                    {
                                                        estadoArray.map(({ idEstado, descripcion }) => (
                                                            <MenuItem key={idEstado} value={idEstado}>{descripcion}</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <FormControl fullWidth>

                                                <InputLabel>Municipio</InputLabel>
                                                <Select
                                                    label="Municipio"
                                                    value={ municipio }
                                                    onChange={ e => setMunicipio( e.target.value) }
                                                    disabled={ estado === 0 }
                                                >
                                                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                                                    {
                                                        municipioArray.map(({ idMunicipio, descripcion }) => (
                                                            <MenuItem key={idMunicipio} value={idMunicipio}>{descripcion}</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>

                                            <Autocomplete
                                                disabled={ municipio === 0 }
                                                disablePortal
                                                fullWidth
                                                value={ autocompleteValue }
                                                options={ asentamientoArray }
                                                onChange={(_, value) => {
                                                    setAsentamiento( value?.idAsentamiento ?? 0 );
                                                    setAutocompleteValue( value );
                                                }}
                                                getOptionLabel={ option => option.asentamiento }
                                                renderOption={( props, option ) => (
                                                    <li {...props} key={ option.idAsentamiento }>
                                                        <strong>{ option.asentamiento }</strong>&nbsp;(C.P. { option.codigoPostal }) - { option.tipo }
                                                    </li>
                                                )}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label="Asentamiento"
                                                        placeholder='Seleccione una opción'
                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <FormControl fullWidth>

                                                <InputLabel>Tipo Domicilio</InputLabel>
                                                <Select
                                                    label="Tipo Domicilio"
                                                    value={ tipoDomicilio }
                                                    onChange={ e => setTipoDomicilio( e.target.value ) }
                                                >
                                                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                                                    {
                                                        tipoDomicilioArray.map(({ idTipoDomicilio, descripcion }) => (
                                                            <MenuItem key={idTipoDomicilio} value={idTipoDomicilio}>{descripcion}</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Calle o vialidad"
                                                variant="outlined"
                                                autoComplete='off'
                                                value={ descripcion }
                                                onChange={ e => setDescripcion( e.target.value ) }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 3, xs: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Numero Int./Ext."
                                                variant="outlined"
                                                type="number"
                                                autoComplete='off'
                                                value={ numero }
                                                onChange={ e => setNumero( e.target.value ) }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 5, xs: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Referencia"
                                                variant="outlined"
                                                multiline
                                                rows={4}
                                                slotProps={{ inputLabel: { shrink: true } }}
                                                value={ referencia}
                                                onChange={ e => setReferencia( e.target.value ) }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }} display="flex" justifyContent="flex-end">

                                            <Button
                                                variant="contained"
                                                loading={ loading }
                                                onClick={ handleGuardarDomicilio }
                                                disabled={ asentamiento === 0 || descripcion === '' }
                                            >
                                                Agregar domicilio
                                            </Button>

                                        </Grid>

                                    </Grid>

                                </Grid>
                        }

                        <Grid size={{ md: 12, xs: 12 }}>                       

                            <TableContainer sx={{ borderRadius: 3 }}>
                                                                        
                                <Table>
        
                                    <TableHead sx={{ ...TableTheadStyle }}>
        
                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%', fontWeight: 'bold' }}>Estado - Municipio</TableCell>    
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'35%', fontWeight: 'bold' }}>Domicilio</TableCell>                                       
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'35%', fontWeight: 'bold' }}>Referencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'5%', fontWeight: 'bold' }}> </TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            (
                                                rowsPerPage > 0
                                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : rows
                                            )
                                            .map( ( elem ) => {

                                                const { idDomicilio, descripcion, numero, referencia, asentamiento, tipoDomicilio } = elem;
                                                const { estado, municipio } = asentamiento ?? defaultAsentamiento;

                                                return <TableRow key={ idDomicilio }>

                                                    <TableCell> 

                                                        <Typography variant='subtitle1'>
                                                            <strong>{ estado?.descripcion }</strong>
                                                        </Typography> 
                                                
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            ({ municipio?.descripcion })
                                                        </Typography> 
        
                                                    </TableCell>

                                                    <TableCell> 

                                                        <Typography variant='subtitle1'>
                                                            <strong>{ descripcion } #{ numero }, C.P { asentamiento?.codigoPostal }, { asentamiento?.descripcion } </strong>
                                                        </Typography> 
                                                
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            ({ tipoDomicilio?.descripcion })
                                                        </Typography>                                                         
                                                        
                                                    </TableCell>                                                                                                                                   
                                                  
                                                    <TableCell> 

                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            <strong>{ referencia } </strong>
                                                        </Typography> 

                                                    </TableCell>

                                                    <TableCell> 

                                                        <RadioGroup 
                                                            key={ idDomicilio }
                                                            value={ radioSelected }
                                                            onChange={ () => handleChangeRadio( elem ) }
                                                        >                                        

                                                            <Radio value={ idDomicilio } disabled={ !edit } />

                                                        </RadioGroup>

                                                    </TableCell>

                                                </TableRow>

                                            })
                                        }

                                        {
                                            ( rows.length === 0 && !loadingSearch )
                                            ?
                                                <TableRow style={{ height: 73 }}>
        
                                                    <TableCell colSpan={7} align="center">
        
                                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
        
                                                    </TableCell>
        
                                                </TableRow>
                                            :
                                                loadingSearch
                                                &&
                                                    <TableRow style={{ height: 73 }}>
        
                                                        <TableCell colSpan={7} align="center">
        
                                                            <CircularProgress size={32} />
        
                                                        </TableCell>
        
                                                    </TableRow>
                                        }
        
                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>
                
                                            <TableCell colSpan={1}>
                                                <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { rows.length } </Typography>
                                            </TableCell> 
                                        
                                            <TablePagination 
                                                colSpan={8}
                                                rowsPerPageOptions={[ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ]}
                                                count={ rows.length }
                                                rowsPerPage={ rowsPerPage }
                                                page={ page }
                                                onPageChange={ handleChangePage }
                                                onRowsPerPageChange={ handleChangeRowsPerPage }

                                                ActionsComponent={ TablePaginationActions }

                                                labelRowsPerPage="Filas por página"                                            
                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                    return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }                                                                                       
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>
                            
                            </TableContainer>

                        </Grid> 

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCloseDialogDomicilio }>Cancelar</Button>

                    {
                        edit
                        &&                    
                            <Button 
                                variant="contained" 
                                color="primary" 
                                disabled={ !validateSelected }
                                loading={ loadingGuardar }
                                onClick={ handleAsignarDomicilio } 
                            >
                                Guardar
                            </Button>
                    }

                </DialogActions>

            </Dialog>
        </>
    )
}